import VueRouter, { RouterOptions } from "vue-router";

import { store } from "./store";

import { RealestateOverview } from "./realestates-overview";
import { RealestateDetails } from "./realestate-details";
import { RentsOverview } from "./rents-overview";
import { RentDetails } from "./rent-details";

const router = new VueRouter({
    mode: "history",
    routes: [
        { name: "realestate", path: "/:author?/:lang?/:home?/:liegenschaften?/realestate", component: RealestateOverview, props: true },
        { name: "realestatedetail", path: "/:author?/:lang?/:home?/:mietobjekte?/realestate/detail/:id", component: RealestateDetails, props: true },
        { name: "rents", path: "/:author?/:lang?/:home?/:mietobjekte?/rents", component: RentsOverview, props: true },
        { name: "rentsdetail", path: "/:author?/:lang?/:home?/:mietobjekte?/rents/detail/:id", component: RentDetails, props: true },
    ],
} as RouterOptions);

let scrollPosition = 0;

router.beforeEach((to: any, from: any, next: any) => {

    if (from.name === "realestate" || from.name === "rents") {
        scrollPosition = window.pageYOffset;
    }

    if (to.name === "detail") {
        store.commit("updateDetails", {});
    }

    next();
});

router.afterEach((to: any) => {
    if (to.name === "realestatedetail" || to.name === "rentdetail") {
        window.scrollTo(0, 0);
    } else if (to.name === "realestate" && scrollPosition > 0) {
        window.scrollTo(0, scrollPosition);
    } else if (to.name === "rents" && scrollPosition > 0) {
        window.scrollTo(0, scrollPosition);
    }
});

export { router };



// WEBPACK FOOTER //
// ./src/components/router.ts